var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 5.19057L13.8094 0.999949C13.6708 0.859923 13.5058 0.748766 13.3239 0.672905C13.1421 0.597043 12.947 0.557983 12.75 0.557983C12.553 0.557983 12.3579 0.597043 12.1761 0.672905C11.9942 0.748766 11.8292 0.859923 11.6906 0.999949L0.440626 12.2499C0.300843 12.3887 0.189933 12.5537 0.114303 12.7355C0.0386743 12.9174 -0.000174814 13.1124 5.91327e-07 13.3093V17.4999C5.91327e-07 17.8978 0.158036 18.2793 0.43934 18.5606C0.720645 18.8419 1.10218 18.9999 1.5 18.9999H5.69063C5.88756 19.0001 6.08257 18.9613 6.26441 18.8856C6.44624 18.81 6.61128 18.6991 6.75 18.5593L18 7.30932C18.2783 7.02693 18.4342 6.6464 18.4342 6.24995C18.4342 5.8535 18.2783 5.47297 18 5.19057ZM5.69063 17.4999H1.5V13.3093L9.75 5.05932L13.9406 9.24995L5.69063 17.4999ZM15 8.19057L10.8094 3.99995L12.75 2.05932L16.9406 6.24995L15 8.19057Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.19261fe25ad6d42b125ef2c7f50a3b8f.svg";
export { ForwardRef as ReactComponent };